import en from './en.json'
import it from './it.json'

export const sharedTranslations = {
	en,
	it
} as const
